module.exports = __webpack_public_path__ + "img/woman-normal-bg-coffee.1b140f4a.png";